import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=0b57ffa3&"
import script from "./ProjectList.vue?vue&type=script&lang=js&"
export * from "./ProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b57ffa3')) {
      api.createRecord('0b57ffa3', component.options)
    } else {
      api.reload('0b57ffa3', component.options)
    }
    module.hot.accept("./ProjectList.vue?vue&type=template&id=0b57ffa3&", function () {
      api.rerender('0b57ffa3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectList.vue"
export default component.exports